// extracted by mini-css-extract-plugin
export default {"mobile-row":"Checkbox_mobile-row__Kf1JD","customCheckbox":"Checkbox_customCheckbox__c4W9d"};